import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-249410d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-item-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "팔로우", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_5 = { class: "content" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("님이 회원님을 팔로우합니다. ")
const _hoisted_8 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, [
        _createElementVNode("a", { href: _ctx.followerUrl }, _toDisplayString(_ctx.notification.follower.name), 9, _hoisted_6),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.longCreateAt), 1)
  ]))
}